/* eslint-disable no-unused-vars */
import { color, Common } from '@stockbit/ui';
import Image from 'global/Image';
import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { effects as chatEffects } from 'lib/entities/chat/slice';
import ModalShare from 'global/ModalShare';
import { PROJECT_FOLDER } from 'constants/app';
import { selectors as profileSelectors } from 'lib/entities/profile';
import { StreamPostData } from '../../../../@types/stream';
import {
  ModalTipping,
  ModalLike,
  ModalInsight,
} from '../../StreamWidget/Modals';
import { FooterContainer } from '../../StreamWidget/Post/styled';
import { effects } from '../../StreamWidget/slice';

const { Flex, Text, Iconmoon, IconWrapper } = Common;

interface FooterProps {
  post: StreamPostData;
  onComment?: () => any;
}

function Footer({ post, onComment }: FooterProps) {
  const dispatch = useDispatch();
  const { data: profileData } = useSelector(profileSelectors);
  const { country = 'ID' } = profileData;

  const [modalShare, showModalShare] = useState(false);
  const [modalTipping, showModalTipping] = useState(false);
  const [modalLike, showModalLike] = useState(false);
  const [modalInsight, showModalInsight] = useState(false);

  const { likes, replies, liked, postid } = post;

  const handleLikePost = () => {
    const action = liked ? effects.unlikePost : effects.likePost;
    dispatch(action(postid));
  };

  const handleShareToChat = async (chatData) => {
    const send = await dispatch(
      chatEffects.sendBulkChat({
        ...chatData,
        attachment_url: '',
        shared_content: {
          type: 'SHARED_CONTENT_TYPE_STREAM',
          id: post.postid,
        },
      }),
    );
    // @ts-ignore
    const { error } = send.payload;

    if (!error) {
      showModalShare(false);
    }
  };

  const urlToShare = useMemo(() => {
    const path =
      !PROJECT_FOLDER || PROJECT_FOLDER === '/' ? '/' : `/${PROJECT_FOLDER}/`;
    return `${window.location.origin}${path}post/${post.postid}`;
  }, [post]);

  return (
    <FooterContainer style={{ marginBottom: '0px' }}>
      <Flex justify="space-between" align="flex-end">
        <Flex align="flex-end">
          <div>
            {likes > 0 && (
              <Text
                as="a"
                className="likes-info"
                onClick={() => showModalLike(true)}
              >
                {likes} likes
              </Text>
            )}
            <Flex padding="10px 20px 0 0">
              <IconWrapper onClick={handleLikePost}>
                {liked ? (
                  <Image
                    src="/icon/post-stream/like-fill.svg"
                    alt="Like post filled"
                    style={{ width: '20px' }}
                  />
                ) : (
                  <Image
                    src="/icon/post-stream/like.svg"
                    alt="Like post"
                    style={{ width: '20px' }}
                  />
                )}
              </IconWrapper>
            </Flex>
          </div>
          <Flex padding="0 20px 0 0">
            <IconWrapper onClick={() => showModalShare(true)}>
              <Image
                src="/icon/post-stream/share.svg"
                alt="Share post"
                style={{ width: '20px' }}
              />
            </IconWrapper>
          </Flex>
          {post.analytics && (
            <IconWrapper
              padding="0 20px 0 0"
              onClick={() => showModalInsight(true)}
            >
              <Iconmoon
                className="icon-new_analytics"
                size="16px"
                color={color.dimgray}
                hoverColor={color.dimgray}
              />
            </IconWrapper>
          )}
          {!post.is_author && country === 'ID' && (
            <IconWrapper
              padding="0 20px 0 0"
              onClick={() => showModalTipping(true)}
            >
              <Image
                src="/icon/post-stream/icon-tip.svg"
                alt="Icon Tip"
                style={{ width: '20px' }}
              />
            </IconWrapper>
          )}
        </Flex>

        <Flex style={{ alignItems: 'flex-end' }}>
          <Text padding="0 8px 0">{parseInt(replies, 10) > 0 && replies}</Text>
          <IconWrapper onClick={onComment}>
            <Image
              src="/icon/post-stream/comment.svg"
              alt="Icon Comment New"
              style={{ width: '20px' }}
            />
          </IconWrapper>
        </Flex>
      </Flex>

      <ModalShare
        post={post}
        sendChat={handleShareToChat}
        title="Share"
        hasCopyButton
        hasRepostButton={post.is_author === 0}
        hasSearchPeople
        hasSocialMedia
        hasShareInput
        urlToShare={urlToShare}
        visible={modalShare}
        onCancel={() => showModalShare(false)}
      />
      <ModalTipping
        streamId={postid}
        userId={post.userid}
        username={post.username}
        avatar={post.avatar}
        visible={modalTipping}
        onCancel={() => showModalTipping(false)}
      />
      <ModalLike
        likes={likes}
        streamId={postid}
        visible={modalLike}
        onCancel={() => showModalLike(false)}
      />
      <ModalInsight
        visible={modalInsight}
        post={post}
        onCancel={() => showModalInsight(false)}
      />
    </FooterContainer>
  );
}

export default Footer;
